module.exports = __webpack_public_path__ + "img/marriott.dd66a82f.jpg";